import axios from "axios";
import React, { useState } from "react";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Col,
  Spinner,
} from "reactstrap";
import Cookies from "universal-cookie";
import Swal from "sweetalert2"; // ✅ Importa SweetAlert2
import logo from "../../assets/img/LOGO-Icontec-2019_ver_pos (2).png";

const Login = () => {
  const cookie = new Cookies();
  const [postCorreo, setPostCorreo] = useState("");
  const [postContrasena, setPostContrasena] = useState("");
  const [loading, setLoading] = useState(false);

  const postData = (e) => {
    e.preventDefault();
    setLoading(true);

    axios({
      method: "post",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://inspecciongnvback-dev.azurewebsites.net/api/v1/Login",
      data: {
        correo: postCorreo,
        contrasena: postContrasena,
      },
    })
      .then((response) => {
        const respuesta = response.data;

        if (!respuesta || !respuesta.id) {
          throw new Error("Usuario no encontrado");
        }

        const expirationDate = new Date();
        expirationDate.setHours(expirationDate.getHours() + 12);

        cookie.set("id", respuesta.id, { path: "/", expires: expirationDate });
        cookie.set("usuario", respuesta.usuario, {
          path: "/",
          expires: expirationDate,
        });
        cookie.set("nombre", respuesta.nombre, {
          path: "/",
          expires: expirationDate,
        });
        cookie.set("correo", respuesta.correo, {
          path: "/",
          expires: expirationDate,
        });
        cookie.set("regionalId", respuesta.regionalId, {
          path: "/",
          expires: expirationDate,
        });
        cookie.set("tipoUsuarioId", respuesta.tipoUsuarioId, {
          path: "/",
          expires: expirationDate,
        });
        cookie.set("tallerId", respuesta.tallerId, {
          path: "/",
          expires: expirationDate,
        });
        cookie.set("estado", respuesta.estado, {
          path: "/",
          expires: expirationDate,
        });

        // ✅ Verificar estado del usuario
        if (respuesta.estado !== "Activo") {
          Swal.fire({
            title: "Usuario Inactivo",
            text: "Tu usuario está inactivo, no puedes acceder al sistema.",
            icon: "error",
            confirmButtonText: "Aceptar",
          });
          return; // 🚫 No continuar
        }

        // ✅ Mensaje con SweetAlert2 si el usuario está activo
        Swal.fire({
          title: `¡Bienvenido, ${cookie.get("nombre")}!`,
          icon: "success",
          confirmButtonText: "Continuar",
        }).then(() => {
          window.location.href = "/admin/Ordenes";
        });
      })

      .catch((error) => {
        console.log(error);
        if (error.response && error.response.status === 404) {
          Swal.fire({
            title: "Usuario no encontrado",
            text: "Por favor, verifica tus credenciales.",
            icon: "error",
          });
        } else {
          Swal.fire({
            title: "Error",
            text: "No se pudo iniciar sesión. Inténtalo de nuevo.",
            icon: "error",
          });
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <Col lg="5" md="7">
        <Card className="bg-secondary shadow border-3">
          <CardHeader className="bg-transparent pb-5 shadow border-9">
            <center>
              <img src={logo} width="100" alt="Logo Icontec" />
            </center>
            <center>INSPECCIÓN DE VEHÍCULOS</center>
            <hr />
            <div className="btn-wrapper text-center">
              <Button
                className="btn-neutral btn-icon"
                color="default"
                href="#pablo"
                onClick={(e) => e.preventDefault()}
              >
                <span className="btn-inner--icon">
                  <img
                    alt="Microsoft"
                    src="https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg"
                    style={{
                      width: "20px",
                      height: "20px",
                      marginRight: "5px",
                    }}
                  />
                </span>
                <span className="btn-inner--text">Microsoft</span>
              </Button>
            </div>
          </CardHeader>
          <CardBody className="px-lg-3 py-lg-3">
            <Form role="form">
              <FormGroup className="mb-3">
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-email-83" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    placeholder="Correo"
                    type="email"
                    autoComplete="new-email"
                    onChange={(e) => setPostCorreo(e.target.value)}
                  />
                </InputGroup>
              </FormGroup>
              <FormGroup>
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-lock-circle-open" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    placeholder="Contraseña"
                    type="password"
                    autoComplete="new-password"
                    onChange={(e) => setPostContrasena(e.target.value)}
                  />
                </InputGroup>
              </FormGroup>

              <div className="text-center">
                <Button
                  className="my-4"
                  color="primary"
                  type="button"
                  onClick={postData}
                  disabled={loading}
                >
                  {loading ? <Spinner size="sm" /> : "Sign in"}
                </Button>
              </div>
            </Form>
          </CardBody>
        </Card>
      </Col>
    </>
  );
};

export default Login;
